import { action } from 'satcheljs';

export type SettingNameType =
    | 'spelling'
    | 'grammar'
    | 'refinements'
    | 'locale'
    | 'textPredictionEnabled'
    | 'finalDatePremiumDemo'
    | 'premiumSuggestionsCount'
    | 'startDatePremiumPreview'
    | 'weekCounter';

export const updateSettingDirectly = action(
    'updateSettingDirectly',
    (settingName: SettingNameType, newValue: boolean | string | number) => ({
        settingName: settingName,
        newValue: newValue,
    })
);
